<template>
    <div :style="appStyleProps"
         data-smooth-scroll="main"
         class="marketplace-body-footer-container d-flex flex-column vh-100 overflow-x-hidden"
         :class="{'customized-affiliate': !!affiliateCustomizations}">
      <div class="d-flex flex-lg-grow-1 align-items-center align-items-lg-start flex-column mb-auto">
        <div class="px-5 px-lg-0 py-lg-0 marketplace-page"
             :class="{'customized-affiliate': !!affiliateCustomizations}">
          <slot />
        </div>
      </div>
    </div>
</template>

<script>
import { mapState } from 'pinia'
import { useUserStore } from '~/store/user'
import { useRootStore } from '~/store/root'
import SmoothScroll from '~/libs/smooth-scroll'
import { useProgressStore } from '~/store/progress'
import { useDocumentsStore } from '~/store/documents'
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization'
import env from '~/libs/env'

export default {
  data() {
    return {
      showModal: false
    }
  },
  async setup() {
    const rootStore = useRootStore()
    const affiliateCustomizationsStore = useAffiliateCustomizationStore()
    rootStore.setPageTitle(affiliateCustomizationsStore.headTitlePrefix)

    rootStore.setLendioFavicons()

    useHead({
      title: rootStore.pageTitle,
      link: rootStore.favicons,
    })
  },
  watch: {
    '$route.path' () {
      SmoothScroll.goTo(0)
      SmoothScroll.scrollElementsTop('[data-smooth-scroll="main"]')
    },
  },
  computed: {
    ...mapState(useProgressStore, ['currentApp']),
    ...mapState(useRootStore, {
      authUser: (store) => store.authUser
    }),
    ...mapState(useAffiliateCustomizationStore, ['appStyleProps', 'affiliateCustomizations']),
  },
  async mounted() {
    await useProgressStore().fetchProgress()
    await useDocumentsStore().getDocuments()
    const piniaUserStore = useUserStore()
    await piniaUserStore.loadFreshLogin()
  },
  methods: {
    openModal() {
      this.showModal = true
    }
  }
}
</script>

<style lang="scss" scoped>

.marketplace-body-footer-container {
  @include media-breakpoint-up(lg) {
    padding-left: 400px;
  }

  &.customized-affiliate {
    background: $app-body-background-color;
  }
}
.marketplace-page {
  width: 100%;
  @include media-breakpoint-down(lg) {
    max-width: 365px;
    margin-top: calc(90px + var(--offset-top, 0px));
  }
  @include media-breakpoint-up(lg) {
    width: 600px;
    margin-top: 90px; /* Spaced to match .sidebar-nav in MarketplaceSidebar minus back btn and 16 margin */
  }
  .no-value-select {
    color: $type-400
  }

  &.customized-affiliate {
    @include affiliateCustomizedApp();
  }
}

.no-back-button-padding {
  padding-top: 58px; /* When a back button is included it takes up 58px */
}

.marketplace-header {
  :not(h3) {
    color: $type-500;
  }
}

.marketplace-content {
  > * {
    margin-bottom: 24px;
  }
}

.marketplace-content > :last-child {
  margin-bottom: 32px !important;
}

.marketplace-content > *:not(.marketplace-content-wide) {
  max-width: 360px;
}

.marketplace-content-wide {
  @include media-breakpoint-up(lg) {
    width: 600px;
  }
}
</style>
